export const ESPECIAL_CASE_TYPE_RESULTS_IDS = [363, 364, 365, 366]
